<template>
  <div>
    <component v-if="!headless" :is="header" />
    <Status v-if="isAuthenticated" />
    <Article />
    <BottomNavigation v-if="bottomNavigation" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'DefaultLayout',
  components: {
    Article: () => import('@/components/common/layout/Article.vue'),
    BottomNavigation: () => import('@/components/common/layout/BottomNavigation.vue'),
    Status: () => import('@/components/me/Status.vue'),
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapState('ui/header', ['headless']),
    bottomNavigation() {
      return !this.$route.meta?.ui?.bottomless && this.isAuthenticated
    },
    header() {
      const name = this.$route.meta?.ui?.newHeader ? 'NewHeader' : 'Header'
      return () => import(`@/components/common/layout/${name}.vue`)
    },
  },
}
</script>
